export default "__VITE_ASSET__Dq12MORN__"